import React, { useEffect, useState } from 'react'
import { Table } from "antd";
import { Link, useNavigate } from 'react-router-dom';
import Cookies from "js-cookie";
import { useDispatch, useSelector } from 'react-redux';
import { getModuleList, getRoleList } from '../../Redux/action/Admin/RolePermissionAction';
import { toast } from 'react-toastify';
import Beatloader from "../../Common/Loaders/Beatloader";
import Offcanvas from 'react-bootstrap/Offcanvas';
import AddRolesForm from './ModalForms/AddRolesForm';
import ViewRoles from './ModalForms/ViewRoles';
import EditRolesForm from './ModalForms/EditRolesForm';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import { adminMainUrl } from "../../Config"


const List = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showLoader, setShowLoader] = useState(true);
    const [listing, setListing] = useState([]);
    const [originalData, setOriginalData] = useState([]);
    const [searchString, setSearchString] = useState("");
    const [showRoleID, setShowRoleID] = useState("");
    const [dataSource, setDataSource] = useState([]);
    const [spinnerLoader, setSpinnerLoader] = useState(false)
    const [reload, setReload] = useState(false);
    const [grid, setGrid] = useState(true)
    const [list, setList] = useState([]);
    const [currentData, setCurrentData] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [dataOffset, setDataOffset] = useState(0);
    const dataPerPage = 10;
    //modals 
    const [showAdd, setShowAdd] = useState(false);
    const handleCloseAdd = () => setShowAdd(false);
    const handleShowAdd = () => setShowAdd(true);
    const [showView, setShowView] = useState(false);
    const handleCloseView = () => setShowView(false);
    const handleShowView = () => setShowView(true);
    const [showEdit, setShowEdit] = useState(false);
    const handleCloseEdit = () => setShowEdit(false);
    const handleShowEdit = () => setShowEdit(true);
    useEffect(() => {
        const endOffset = dataOffset + dataPerPage;
        setCurrentData(list.slice(dataOffset, endOffset));
        setPageCount(Math.ceil(list.length / dataPerPage));
    }, [dataOffset, dataPerPage, list]);

    const handlePageClick = (event) => {
        window.scroll(0, 0);
        const newOffset = (event.selected * dataPerPage) % list.length;
        setDataOffset(newOffset);
    };
    console.log(list, "list............")
    const columns = [
        {
            title: 'S. No.',
            dataIndex: 'S. No.',
            key: 'S. No.',
        },
        {
            title: 'Role',
            dataIndex: 'Role',
            key: 'Role',
        },
        {
            title: 'Action',
            dataIndex: 'Action',
            key: 'Action',
        },
    ];

    const [selectedRowKeys, setSelectedRowKeys] = useState([])

    const onSelectChange = newSelectedRowKeys => {
        setSelectedRowKeys(newSelectedRowKeys)
    }

    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange
    }



    //redux for getting data
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get("token");

    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            dispatch(getRoleList());
            dispatch(getModuleList());
        }
    }, []);


    const reloadComponent = () => {
        dispatch(getRoleList());
    }

    const { loadingRoleListApi, roleListDataError, roleListData } = useSelector((state) => state?.RolePermissionReducer);

    let { loadingModuleList, moduleListDataError, moduleListData } = useSelector(state => state?.RolePermissionReducer);

    useEffect(() => {
        if (loadingModuleList) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        };

        if (moduleListData) {
            setListing(moduleListData);
        }

    }, [loadingModuleList, moduleListDataError, moduleListData]);

    useEffect(() => {
        if (loadingRoleListApi) {
            setShowLoader(true);
        } else {
            setShowLoader(false);
        }
        if (roleListData) {
            setList(roleListData);
            setOriginalData(roleListData);
        }
    }, [loadingRoleListApi, roleListDataError, roleListData]);

    useEffect(() => {
        if (list) {
            let arr = list.map((val, _i) => {
                return {
                    "S. No.": _i + 1,
                    "Role": val.name,
                    "Action": <div className="dropdown table-action" >
                        <Link
                            to="#"
                            className="action-icon"
                            data-bs-toggle="dropdown"
                            aria-expanded="true"
                        >
                            <i className="fa fa-ellipsis-v"></i>
                        </Link>
                        <div
                            className="dropdown-menu dropdown-menu-right"
                            style={{
                                position: "absolute",
                                inset: "0px auto auto 0px",
                                margin: "0px",
                                transform: "translate3d(-99.3333px, 35.3333px, 0px)",
                            }}
                            data-popper-placement="bottom-start"
                        >
                            <Link
                                className="dropdown-item edit-popup"
                                to="#"
                                onClick={() => { setShowEdit(true); setShowRoleID(val?.id) }}
                            >
                                <i className="ti ti-edit text-blue"></i> Edit
                            </Link>
                            <Link className="dropdown-item" to="#" onClick={() => { setShowView(true); setShowRoleID(val?.id) }}><i className="ti ti-eye text-blue-light"></i> Preview</Link>
                        </div>
                    </div>
                }
            })
            setDataSource(arr)
        }
    }, [list])


    useEffect(() => {
        if (searchString) {
            const filteredRoles = list.filter((role) =>
                role.name.toLowerCase().includes(searchString.toLowerCase())
            );
            setList(filteredRoles);
        } else {
            setList(originalData);
        }
    }, [searchString]);


    return (
        <>
            {
                showLoader ?
                    <Beatloader />
                    :
                    <div className="page-wrapper">
                        <div className="content">
                            <div className="row">
                                <div className="col-md-12">
                                    {/* Page Header */}
                                    <div className="page-header">
                                        <div className="row align-items-center">
                                            <div className="col-8">
                                                <h4 className="page-title">
                                                    Roles List <span className="count-title">({roleListData ? roleListData.length : 0})</span>
                                                </h4>
                                            </div>

                                        </div>
                                    </div>
                                    {/* /Page Header */}
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-1">
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="icon-form">
                                                <span className="form-icon">
                                                    <i className="ti ti-search" />
                                                </span>
                                                <input
                                                    type="text"
                                                    className="form-control bookingrange"
                                                    placeholder="Type to search Role"
                                                    onChange={(e) => { setSearchString(e.target.value) }}
                                                />
                                            </div>

                                        </div>
                                        <div className="d-flex align-items-center flex-wrap row-gap-2">
                                            <div className="add">
                                                <button className="btn btn-sm btn-primary" onClick={() => setShowAdd(true)}><i className="ti ti-plus" /> Add Role</button>
                                            </div>
                                            {/* <div className="view-icons ms-2">
                                                <Link onClick={() => { setGrid(true) }} className={`${grid === true && "active"}`}>
                                                    <i className="ti ti-list-tree" />
                                                </Link>
                                                <Link onClick={() => { setGrid(false) }} className={`${grid === false && "active"}`}>
                                                    <i className="ti ti-grid-dots" />
                                                </Link>
                                            </div> */}
                                        </div>
                                    </div>
                                    {
                                        grid ?

                                            <div className="table-responsive custom-table">
                                                <Table className="table datanew dataTable no-footer"
                                                    // rowSelection={rowSelection}
                                                    dataSource={dataSource}
                                                    columns={columns}
                                                />
                                            </div> :
                                            <div className='row'>
                                                {
                                                    list?.length > 0 ?
                                                        list?.map((value, i) => {
                                                            return (
                                                                <div key={i} className="col-xxl-3 col-xl-4 col-md-6">
                                                                    <div className="card border">
                                                                        <div className="card-body">
                                                                            <div className="d-flex align-items-center justify-content-between mb-3">
                                                                                <div className="d-flex align-items-center">
                                                                                    <a
                                                                                        href="contact-details.html"
                                                                                        className="avatar avatar-md flex-shrink-0 me-2"
                                                                                    >
                                                                                        <img
                                                                                            src="/assets/img/profiles/avatar-19.jpg"
                                                                                            alt="img"
                                                                                        />
                                                                                    </a>
                                                                                    <div>
                                                                                        <h6>
                                                                                            <a
                                                                                                href="contact-details.html"
                                                                                                className="fw-medium"
                                                                                            >
                                                                                                {value?.name}
                                                                                            </a>
                                                                                        </h6>
                                                                                        {/* <p className="text-default">{value?.origin_type == "AIRPORT" ? "Delhi, India" : `${value?.origin_address}, ${value?.origin_city ? value?.origin_city?.name : ""}, ${value?.origin_state ? value?.origin_state?.name : ""}, ${value?.origin_country ? value?.origin_country?.name : ""} `}</p> */}
                                                                                    </div>
                                                                                </div>
                                                                                <div className="dropdown table-action">
                                                                                    <a
                                                                                        href="#"
                                                                                        className="action-icon "
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                    >
                                                                                        <i className="fa fa-ellipsis-v" />
                                                                                    </a>
                                                                                    <div className="dropdown-menu dropdown-menu-right">

                                                                                        <Link
                                                                                            className="dropdown-item edit-popup"
                                                                                            to="#"
                                                                                            onClick={() => { setShowEdit(true); setShowRoleID(value?.id) }}
                                                                                        >
                                                                                            <i className="ti ti-edit text-blue"></i> Edit
                                                                                        </Link>
                                                                                        <Link className="dropdown-item" to="#" onClick={() => { setShowView(true); setShowRoleID(value?.id) }}><i className="ti ti-eye text-blue-light"></i> Preview</Link>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                            <div className="d-block">
                                                                                <div className="d-flex flex-column mb-3">
                                                                                    <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                        <i className="ti ti-mail text-dark me-1" />
                                                                                        {value?.email}
                                                                                    </p>
                                                                                    <p className="text-default d-inline-flex align-items-center mb-2">
                                                                                        <i className="ti ti-phone text-dark me-1" />
                                                                                        {value?.phone}
                                                                                    </p>
                                                                                    <p className="text-default d-inline-flex align-items-center">
                                                                                        <i className="ti ti-map-pin-pin text-dark me-1" />
                                                                                        {value?.origin_type == "AIRPORT" ? "Mumbai, India" : `${value?.destination_address}, ${value?.destination_city ? value?.destination_city?.name : ""}, ${value?.destination_state ? value?.destination_state?.name : ""}, ${value?.destination_country ? value?.destination_country?.name : ""} `}
                                                                                    </p>
                                                                                </div>
                                                                                <div className="d-flex align-items-center">
                                                                                    <span className="badge badge-tag badge-success-light me-2">
                                                                                        {value?.quote_status?.name}
                                                                                    </span>
                                                                                    {/* <span className="badge badge-tag badge-warning-light">
                                                           Rated
                                                       </span> */}
                                                                                </div>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        }) :
                                                        <div className="box-grid">
                                                            No data available
                                                        </div>
                                                }
                                            </div>
                                    }
                                    <div className="row align-items-center">
                                        <div className="col-md-6">
                                            <div className="datatable-length" />
                                        </div>
                                        <div className="col-md-6">
                                            <div className="datatable-paginate" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            }

            {/* Add Role Modal */}
            <Offcanvas show={showAdd} onHide={handleCloseAdd} placement={"end"} name={"end"} backdrop="static" className="add-offcanvas-role">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Role</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <AddRolesForm listing={listing} adminMainUrl={adminMainUrl} handleCloseAdd={handleCloseAdd} reloadComponent={reloadComponent} />
                </Offcanvas.Body>
            </Offcanvas>


            {/* View Role Modal */}
            <Offcanvas show={showView} onHide={handleCloseView} placement={"end"} name={"end"} backdrop="static" className="add-offcanvas-role">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Role Information</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <ViewRoles roleID={showRoleID} handleCloseView={handleCloseView} />
                </Offcanvas.Body>
            </Offcanvas>

            {/* Edit Role Modal */}
            <Offcanvas show={showEdit} onHide={handleCloseEdit} placement={"end"} name={"end"} backdrop="static" className="add-offcanvas-role">
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Edit Role</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <EditRolesForm roleID={showRoleID} handleCloseEdit={handleCloseEdit} adminMainUrl={adminMainUrl} reloadComponent={reloadComponent} />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default List